import { TelegramIcon } from '@/icons';
import { ReactNode } from 'react';

const enum SocialLink {
  MESSENGER = "messenger",
  INSTAGRAM = "instagram",
  TELEGRAM = "telegram",
  VIBER = "viber",
}

type LinkConfig = {
  key: SocialLink;
  title: string;
  href: string;
  icon?: ReactNode;
  target?: '_blank' | string;
};

export const socialLinksConfig: LinkConfig[] = [
  {
    key: SocialLink.TELEGRAM,
    title: 'Telegram',
    href: 'https://telegram.me/MyCredit_online_ua_bot',
    icon: <TelegramIcon />,
    target: '_blank',
  }
];
